export { SizeSmallIconNo } from "./SizeSmallIconNo";
